var Owl2Carouselv2 = function () {

    return {

	// Owl Carousel v1
	initOwl2Carouselv2: function () {
	    $('.owl2-carousel-equipe').owlCarousel({
		items: 4,
		margin: 30,
		autoplay: false,
		loop: false,
		nav: true,
		dots: false,
		navText: ["<span class='fa fa-chevron-left'></span>","<span class='fa fa-chevron-right'></span>"],
		navContainerClass: 'owl-buttons',
                autoplay: false,
                rewindNav:false,
		responsive: {
		    0:{
			items: 1
		    },
		    768:{
			items: 2
		    },
		    992:{
			items: 3
		    },
		    1200:{
			items: 4
		    }
		}
	    });

            $('.owl-clients-secteurs').owlCarousel({
                items : 6,
                autoplay : 4000,
		dots: true,
                nav: false,
                loop: true,
		responsive: {
		    0:{
			items: 2
		    },
		    768:{
			items: 3
		    },
		    992:{
			items: 4
		    },
		    1200:{
			items: 6
		    }
		}
            });
        }

    };

}();

$(function() {
    $(".infoblocks").slick({
        // autoplay: true,
        arrows: true,
        dots: true,
        slidesToShow: 1,
        appendDots: '.service-list',
        customPaging : function(slider, i) {
            var title = $(slider.$slides[i]).data('title');
            return '<span class="line-icon '+ $(slider.$slides[i]).data('class') + '"></span> <strong>'+title+'</strong>';
        }
    });
});

$(function() {
  $('.references-nav').on('click', '.slick-slide', function (e) {
    e.stopPropagation();
    var index = $(this).data('slick-index');
    if ($('.references-nav').slick('slickCurrentSlide') !== index) {
      $('.references-nav').slick('slickGoTo', index);
    }
  });
  $('.references-nav').slick({
    centerMode: true,
    slidesToShow: 5,
    asNavFor: '.references-content',
    infinite: true,
    arrows: false
  });

  $('.references-content').slick({
    slidesToShow: 1,
    infinite: true,
    arrows: false,
    asNavFor: '.references-nav',
    dots: true
  });
});


function initMap() {
  var customMapType = new google.maps.StyledMapType(
[
    {
        "featureType": "administrative",
        "elementType": "labels.text.fill",
        "stylers": [
            {
                "color": "#444444"
            }
        ]
    },
    {
        "featureType": "landscape",
        "elementType": "all",
        "stylers": [
            {
                "color": "#eef2f7"
            }
        ]
    },
    {
        "featureType": "poi",
        "elementType": "all",
        "stylers": [
            {
                "visibility": "off"
            }
        ]
    },
    {
        "featureType": "road",
        "elementType": "all",
        "stylers": [
            {
                "saturation": -100
            },
            {
                "lightness": 45
            }
        ]
    },
    {
        "featureType": "road.highway",
        "elementType": "all",
        "stylers": [
            {
                "visibility": "simplified"
            }
        ]
    },
    {
        "featureType": "road.arterial",
        "elementType": "labels.icon",
        "stylers": [
            {
                "visibility": "off"
            }
        ]
    },
    {
        "featureType": "transit",
        "elementType": "all",
        "stylers": [
            {
                "visibility": "off"
            }
        ]
    },
    {
        "featureType": "water",
        "elementType": "all",
        "stylers": [
            {
                "color": "#CFDCE8"
            },
            {
                "visibility": "on"
            }
        ]
    }
], {
      name: 'Logitude'
  });


    var imgURL = require('../img/marker.png');

    var image = new google.maps.MarkerImage(
  	imgURL,
  	new google.maps.Size(48,54),
  	new google.maps.Point(0,0),
  	new google.maps.Point(24,54)
    );

    var customMapTypeId = 'custom_style';

    var map = new google.maps.Map(document.getElementById('map'), {
        zoom: 12,
        scrollwheel: false,
        center: {lat: 48.888679, lng: 2.333372},  // Paris.
        mapTypeControlOptions: {
            mapTypeIds: [google.maps.MapTypeId.ROADMAP, customMapTypeId]
        }
    });

    var infowindow = new google.maps.InfoWindow;
    infowindow.setContent('<b>Logitude</b>');

    var paris = new google.maps.Marker({
  	map: map,
  	clickable: false,
  	icon: image,
  	position: {lat: 48.888679, lng: 2.333372}
    });

    var londres = new google.maps.Marker({
  	map: map,
  	clickable: false,
  	icon: image,
  	position: {lat: 51.5634123, lng: -0.1757812}
    });

    var moscou = new google.maps.Marker({
  	map: map,
  	clickable: false,
  	icon: image,
  	position: {lat: 55.755826, lng: 37.6173}
    });

    var bounds = new google.maps.LatLngBounds();
    bounds.extend(londres.getPosition());
    bounds.extend(moscou.getPosition());

    //center the map to the geometric center of all markers
    map.setCenter(bounds.getCenter());

    map.fitBounds(bounds);

    map.mapTypes.set(customMapTypeId, customMapType);
    map.setMapTypeId(customMapTypeId);
}
window.initMap = initMap;

 $(function() {
   App.init();
   Owl2Carouselv2.initOwl2Carouselv2();
 });


$(function() {
    var image1  = require('../img/brainstorm.jpg');
    var image1b = require('../img/brainstorm-1024.jpg');
    var image2  = require('../img/paperboard.jpg');
    var image2b = require('../img/paperboard-1024.jpg');
    var image3  = require('../img/discussion.jpg');
    var image3b = require('../img/discussion-1024.jpg');

/**
           {width: 1920, url: image1},
           {width: 1024, url: image1b}
       ],
       [
           {width: 1600, url: image2},
           {width: 1024, url: image2b}
       ],
       [
           {width: 1920, url: image3},
           {width: 1024, url: image3b}
       ],
**/

   $(".fullscreen-static-image").backstretch(
       [
           image1, image2, image3
       ],
       {duration: 5000, fade:1500}
   );
 });

 $(function() {
   $('.success-stories').slick({
     infinite: true,
     slidesToShow: 1,
     arrows: true,
     prevArrow: '<div class="slick-prev"><i class="fa fa-chevron-left"></i></div>',
     nextArrow: '<div class="slick-next"><i class="fa fa-chevron-right"></i></div>'
   });
 });



// WEBPACK FOOTER //
// ./assets/js/custom.js